import { render, staticRenderFns } from "./SearchOrders.vue?vue&type=template&id=3b0446be&scoped=true&"
import script from "./SearchOrders.vue?vue&type=script&lang=js&"
export * from "./SearchOrders.vue?vue&type=script&lang=js&"
import style0 from "./SearchOrders.vue?vue&type=style&index=0&id=3b0446be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0446be",
  null
  
)

export default component.exports